import React, { ReactNode } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./HelpInfo.scss";
import { faCircleInfo, IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { Placement } from "react-bootstrap/esm/types";
import { OverlayTriggerType } from "react-bootstrap/esm/OverlayTrigger";

interface IProps {
    title: ReactNode;
    className?: string;
    innerClassName?: string;
    placement?: Placement;
    trigger?: OverlayTriggerType[];
    icon?: IconDefinition;
}

export default function HelpInfo(props: IProps) {
    if (!props.title) {
        return null;
    }
    const popover = (
        <Tooltip id={`popover-info-icon`} className={`${props.innerClassName ? props.innerClassName : ""}`}>
            {props.title}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            trigger={props.trigger ? props.trigger : ["hover", "focus"]}
            overlay={popover}
            placement={props.placement}
        >
            <div className={`infoIcon  ${props.className ? props.className : ""}`}>
                <FontAwesomeIcon icon={props.icon || faCircleInfo} />
            </div>
        </OverlayTrigger>
    );
}
